import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

type TCurrencyPostfix = 'USD' | 'LocalCurrency'

export type TGoalField = Extract<
  keyof TKeyInitiative,
  `Goal${ActualsValueTypes}${TCurrencyPostfix}`
>

export type TIncrementalField = Extract<
  keyof TKeyInitiative,
  `Incremental${ActualsValueTypes}${TCurrencyPostfix}`
>

export const getGoalField = (actualsValueType: ActualsValueTypes, currency: string): TGoalField => {
  const currencyPostfix = currency === 'USD' ? 'USD' : 'LocalCurrency'

  return `Goal${actualsValueType}${currencyPostfix}` as TGoalField
}

export const getInitiativeIncrementalField = (
  actualsValueType: ActualsValueTypes,
  currency: string
): TIncrementalField => {
  const currencyPostfix = currency === 'USD' ? 'USD' : 'LocalCurrency'

  return `Incremental${actualsValueType}${currencyPostfix}` as TIncrementalField
}
